import React from "react";
import "../../pages.css";
import img from "../../../assets/newImages/moeda-estrangeira.png";
import linha from "../../../assets/linha.png";
import { PoliticaEntregaCambio } from "../../../components/text/politcaEntrega";

export default function MoedasEstrangeiras() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">
              MOEDAS ESTRANGEIRAS
            </p>
            <p>
            Na Ourominas, você encontra um serviço completo e seguro para compra e venda de moedas estrangeiras em espécie, com as melhores cotações de câmbio turismo do mercado. Seja para sua próxima viagem internacional ou para sua empresa, oferecemos um atendimento ágil, prático e com total segurança.
          </p>
            <div className="div-line">
              <img src={linha} alt="linha de separação"></img>
            </div>
          </div>
          <div className="col-6 c-init__image">
            <img src={img} className="image" alt="grupo-om"></img>
          </div>
        </div>



  <section className="mt-4 sect">
  <p className=" mt-5 my-3  fw-bolder">PERGUNTAS FREQUENTES</p>
        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">
            POR QUE A OUROMINAS É A MELHOR DTVM?
          </summary>
          <p className="my-4">
            Sabemos que a maioria das pessoas fazem pesquisa de preço e cotação
            entre diferentes casas de câmbio, agora, imagina só a vantagem de
            ver qualquer valor cobrado sendo coberto pela OM? Cobrimos o preço
            da concorrência, através de documento comprobatório. Oferecemos o
            custo-benefício mais positivo.
          </p>
        </details>

        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">
            POR QUE COMPRAR MOEDAS ESTRANGEIRAS COM A OUROMINAS?
          </summary>
          <ol className="mt-4">
            <li>
            Mais de 20 moedas disponíveis, incluindo dólar (USD), euro (EUR), libra (GBP), peso argentino (ARS), entre outras.
            </li>
            <li>
            Atendimento via WhatsApp, telefone, chat online, loja virtual, lojas próprias e autorizadas em todo Brasil.
            </li>
            <li>
            Cotações competitivas e atualizadas em tempo real.
            </li>
            <li>
            Possibilidade de entrega domiciliar segura via Correios ou portador de valores.
            </li>
            <li>Transações autorizadas pelo Banco Central do Brasil. </li>
            <li>Mais de 40 anos de experiência no mercado financeiro. </li>
          </ol>
        </details>

        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">
            QUAL A VANTAGEM DE COMPRAR ONLINE?
          </summary>
          <p className="mt-4">
            Além de economizar o tempo de visitar a casa de câmbio, a cotação
            on-line pode proporcionar preços ainda melhores em relação aos
            locais físicos, já que dispensam toda a sua estrutura. Outra
            vantagem é a praticidade, uma vez que é possível fazer todo o
            processo pelo WhatsApp, loja virtual ou chat online e sem sair de
            casa.
          </p>
          <p>
            Mais seguro. Com a possibilidade de retirar suas notas ou pedir por
            delivery, é possível optar pela forma que você possui mais
            confiança. Vale lembrar que, em caso de extravio ou problemas no
            recebimento do seu pedido, com a OM, você será ressarcido.
          </p>
        </details>

        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">COMPRA COM SEGURANÇA E PRATICIDADE</summary>
          <p className="mt-4">
          Comprar moedas estrangeiras antes da viagem é a maneira mais segura e econômica de garantir tranquilidade ao chegar no destino. Evite custos extras com conversões locais e aproveite mais tempo da sua viagem.
          </p>
          <p>
          Na Ourominas, o processo de compra é simples:
          </p>
          <ul>
          <li>Solicite a cotação da moeda desejada. </li>
          <li>Cadastre-se com seus dados e documentos. </li>
          <li>Realize o pagamento por PIX, TED, ou em espécie (presencialmente). </li>
          <li>Receba suas moedas com segurança, por delivery ou retirada. </li>
          </ul>
          <p><b>Importante: </b> Conforme exigência do Banco Central, o valor creditado na conta da OM deve sair da conta do titular do contrato de câmbio. A operação deverá ser liquidada no prazo combinado, pois do contrário será cancelada. </p>
        </details>

        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">CADASTRO E REQUISITOS OBRIGATÓRIOS</summary>
          <p className="mt-4">
          A Ourominas segue todas as exigências da legislação brasileira para prevenção à lavagem de dinheiro (PLD/FT) é obrigada a seguir os procedimentos cadastrais. A empresa protege as informações de seus clientes e não repassa a terceiros, salvo sob determinação do Banco Central do Brasil.
          </p>
          <p><b>Cadastro Simplificado: </b></p>
          <ol >
            <li>
            Informar e preencher corretamente os dados cadastrais (e-mail, endereço e telefone atualizado.
            </li>
            <li>
            RG e CPF ou CNH e comprovante de endereço.
            </li>
          </ol>

          <p><b>Cadastro Completo: </b></p>
          <ul>
          <li>Documentos e dados acima  </li>
          <li>Declaração e recibo do Imposto de renda PF </li>
          <li>E / ou origem dos recursos. </li>
          </ul>
        </details>

        <PoliticaEntregaCambio/>

        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">ATENDIMENTO ESPECIALIZADO.</summary>
          <p className="my-4">
          Nosso atendimento é personalizado, com consultores preparados para orientar sua compra ou venda de moeda estrangeira com total transparência e segurança.
          </p>
          <p>Produtos e serviços que o cliente encontra através deste canal: </p>
          <ul>
          <li>Moedas estrangeiras em espécie; </li>
          <li>Cartão pré-pago internacional; </li>
          <li>Remessas ou transferências internacionais; </li>
          <li>Sistema de remessa via MoneyGram; </li>
          <li>Seguro-viagem internacional; </li>
          <li>Chip internacional de celular; </li>
          <li>DHL.</li>
          </ul>

          <p>
              <strong>WhatsApp:</strong>{" "}
              <a href="https://wa.me/551123949845" target="_blank" rel="noreferrer">
                11 2394-9845 (somente mensagem)
              </a>
              <br />
              <strong>Telefone:</strong>{" "}
              <a href="tel:+551132180999">11 3218-0999</a>
              <br />
              <strong>E-mail:</strong>{" "}
              <a href="mailto:atendimento@ourominas.com">
                atendimento@ourominas.com
              </a>
            </p>
              <p>Horário de Atendimento: 08h40 às 18h00 dias úteis (exceto feriados)</p>
        </details>

        <details className="mb-2 pb-2 border-bottom">
          <summary className="fw-bold">HORÁRIO DE NEGOCIAÇÃO.</summary>
          <p className="my-4">
            Nosso horário de negociação: Segunda à Sexta, das 8:30 às 18:00h
            (Horário de Brasília). Temos horários diferenciados em alguns pontos
            de atendimento.
          </p>
        </details>

        <p><b>Ourominas Câmbio</b>  – Tradição e confiança no mercado de moedas estrangeiras. </p>
      </section>
      </section>
    </article>
  );
}
